module.exports = __webpack_public_path__ + "media/images/photo/top/album/album1-2560e45de23e7652e16b92d9be280104.jpg";